var React = require('react');

function FeatureFinishline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Finishline"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(-525.000000, -8159.000000)"},React.createElement("g",{"transform":"translate(69.000000, 7650.000000)"},React.createElement("path",{"d":"M464,518 L467,518 L467,515 L464,515 L464,518 Z M461,515 L464,515 L464,512 L461,512 L461,515 Z M464,512 L467,512 L467,509 L464,509 L464,512 Z M470.333333,509 L470.333333,512.2 L467,512.2 L467,515.4 L470.333333,515.4 L470.333333,525 L472,525 L472,509 L470.333333,509 Z M457.666667,515.4 L461,515.4 L461,518.6 L457.666667,518.6 L457.666667,525 L456,525 L456,509 L461,509 L461,512.2 L457.666667,512.2 L457.666667,515.4 Z"}))))]);
}

FeatureFinishline.defaultProps = {"viewBox":"0 0 16 16","version":"1.1"};

module.exports = FeatureFinishline;

FeatureFinishline.default = FeatureFinishline;
